import { render, staticRenderFns } from "./thirdPartyAccess.vue?vue&type=template&id=6378f1cb&scoped=true"
import script from "./thirdPartyAccess.vue?vue&type=script&lang=js"
export * from "./thirdPartyAccess.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyAccess.vue?vue&type=style&index=0&id=6378f1cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378f1cb",
  null
  
)

export default component.exports